import { Component } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../../../../core/animations';

import { SideNavService } from '../../../../../../sidenav.service';

import { userInfo, spekwo } from '../../../../../../../../../utils/index';

@Component({
    selector: 'pro-basic-detail',
    templateUrl: './basicInfo.component.html',
    styleUrls: ['./basicInfo.component.scss'],
    animations: fuseAnimations
})

export class BasicInfoComponent {


    userId = '';
    userData: any = {};
    userInfo = userInfo;
    spekwoValues = spekwo;

    isLoading: boolean = false;
    logoUrl: string;
    photoUrl: string;
    isLogoImageLoaded: boolean = false;
    isProfileImageLoaded: boolean = false;

    onProInfoChangedSubscription: Subscription;

    constructor(
        public sideNavService: SideNavService
    ) {
        this.isLogoImageLoaded = true;
        this.isProfileImageLoaded = true;
    }

    ngOnInit() {

        this.userData = '';
        this.isLoading = true;

        /**Current selected user */
        this.onProInfoChangedSubscription =
            this.sideNavService.onProUserInfoTabSelected.subscribe(selected => {

                this.userData = selected;

                if (this.userData) {
                    this.isLoading = false;
                    this.logoUrl = this.userData.logoUrl ? this.userData.logoUrl : this.spekwoValues.defaultLogo;
                    this.photoUrl = this.userData.photoUrl ? this.userData.photoUrl : this.spekwoValues.defaultImg;
                }
            })

    }

    ngOnDestroy() {
        this.onProInfoChangedSubscription.unsubscribe();
    }

    /**Handling error handle method for pic */
    setDefaultPic(event, profilePic) {
        event.target.src = profilePic === 'yes' ? this.spekwoValues.defaultImg : this.spekwoValues.defaultLogo;
    }

    /**check image loaded or not */
    loadLogoImage() {
        this.isLogoImageLoaded = false;
    }
    loadProfileImage() {
        this.isProfileImageLoaded = false;
    }

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/basic-info/basicInfo.component.ts